module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6sZMh"))).then(() => parcelRequire('fThBo'));